"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _theme = _interopRequireDefault(require("../../theme"));

var _Box = _interopRequireDefault(require("../Box"));

var _Typography = require("../Typography");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _pill = _interopRequireDefault(require("../../theme/pill"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var pills = (0, _styledSystem.variant)({
  key: 'pills'
});
var sizes = (0, _styledSystem.variant)({
  key: 'pillSizes',
  prop: 'size'
});
var PillBox = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Pill__PillBox",
  componentId: "yxrlc-0"
})(["display:inline-flex;align-items:center;", " ", ""], pills, sizes);

var Icon = function Icon() {
  return _react["default"].createElement("svg", {
    width: "10",
    height: "10",
    viewBox: "0 0 32 32",
    fill: "none",
    style: {
      display: 'block'
    },
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("path", {
    d: "M22.0655 16L31.1627 6.90273C32.2791 5.78636 32.2791 3.97636 31.1627 2.85909L29.1409 0.837273C28.0245 -0.279091 26.2145 -0.279091 25.0973 0.837273L16 9.93455L6.90273 0.837273C5.78636 -0.279091 3.97636 -0.279091 2.85909 0.837273L0.837273 2.85909C-0.279091 3.97545 -0.279091 5.78545 0.837273 6.90273L9.93455 16L0.837273 25.0973C-0.279091 26.2136 -0.279091 28.0236 0.837273 29.1409L2.85909 31.1627C3.97545 32.2791 5.78636 32.2791 6.90273 31.1627L16 22.0655L25.0973 31.1627C26.2136 32.2791 28.0245 32.2791 29.1409 31.1627L31.1627 29.1409C32.2791 28.0245 32.2791 26.2145 31.1627 25.0973L22.0655 16Z",
    fill: "currentColor"
  }));
};

var DeleteButton = _styledComponents["default"].i.withConfig({
  displayName: "Pill__DeleteButton",
  componentId: "yxrlc-1"
})(["border-radius:100px;display:inline-block;text-align:center;margin-left:4px;cursor:pointer;font-weight:bold;padding:6px;flex:auto;"]);

var Pill = _react["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
      variant = _ref.variant,
      onDelete = _ref.onDelete,
      isRounded = _ref.isRounded,
      props = _objectWithoutProperties(_ref, ["children", "variant", "onDelete", "isRounded"]);

  return _react["default"].createElement(PillBox, _extends({
    ref: ref,
    variant: variant,
    borderRadius: isRounded ? 9999 : 4
  }, props), _react["default"].createElement(_Box["default"], {
    display: "flex"
  }, _react["default"].createElement(_Typography.Text, {
    color: "inherit"
  }, children)), onDelete && _react["default"].createElement(DeleteButton, {
    variant: variant,
    onClick: onDelete
  }, _react["default"].createElement(Icon, null)));
});

Pill.propTypes = {
  isRounded: _propTypes["default"].bool,
  variant: _propTypes["default"].oneOf(Object.keys(_pill["default"].pills)),
  size: _propTypes["default"].oneOf(Object.keys(_pill["default"].pillSizes))
};
Pill.defaultProps = {
  theme: _theme["default"],
  size: 'medium',
  variant: 'default'
};
var _default = Pill;
exports["default"] = _default;